/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 */

const baseUrl = 'academy/learning-center/recommendations';
const pathParameterPlaceholder = undefined;
function freeze(value) {
  return Object.freeze(value);
}

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV2` from
 * `rpc-client-utils`.
 *
 * get-/academy/learning-center/recommendations/v1/control/homepage/{language}
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:RecommendationResource+type:symbol+getControlRecommendations&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Recommendation-get-%2Facademy%2Flearning-center%2Frecommendations%2Fv1%2Fcontrol%2Fhomepage%2F%7Blanguage%7D'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/get/api.hubapi.com%2Facademy%2Flearning-center%2Frecommendations%2Fv1%2Fcontrol%2Fhomepage%2F%28%28%7Blanguage%7D%29%29?showRequestDetails=true&body=&authType=app&headers=Accept:%20application%2Fjson%0AContent-Type:%20*%2F*)</span></span><span style='padding-left: 12px'></span></span>
 */
export const getHomepageRecommendationsRpc = freeze({
  baseUrl,
  method: 'get',
  pathSegments: freeze(['v1/control/homepage', pathParameterPlaceholder]),
  pathParameters: freeze(['language'])
});

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV2` from
 * `rpc-client-utils`.
 *
 * get-/academy/learning-center/recommendations/v1/lesson/{lessonId}
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:RecommendationResource+type:symbol+getLessonRecommendations&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Recommendation-get-%2Facademy%2Flearning-center%2Frecommendations%2Fv1%2Flesson%2F%7BlessonId%7D'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/get/api.hubapi.com%2Facademy%2Flearning-center%2Frecommendations%2Fv1%2Flesson%2F%28%28%7BlessonId%7D%29%29?showRequestDetails=true&body=&authType=app&headers=Accept:%20application%2Fjson%0AContent-Type:%20*%2F*)</span></span><span style='padding-left: 12px'></span></span>
 */
export const getLessonRecommendationsRpc = freeze({
  baseUrl,
  method: 'get',
  pathSegments: freeze(['v1/lesson', pathParameterPlaceholder]),
  pathParameters: freeze(['lessonId'])
});

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV2` from
 * `rpc-client-utils`.
 *
 * get-/academy/learning-center/recommendations/v1/topic-preferences
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:RecommendationResource+type:symbol+getTopicPreference&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Recommendation-get-%2Facademy%2Flearning-center%2Frecommendations%2Fv1%2Ftopic-preferences'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/get/api.hubapi.com%2Facademy%2Flearning-center%2Frecommendations%2Fv1%2Ftopic-preferences?showRequestDetails=true&body=&authType=app&headers=Accept:%20application%2Fjson%0AContent-Type:%20*%2F*)</span></span><span style='padding-left: 12px'></span></span>
 */
export const getTopicPreferenceRpc = freeze({
  baseUrl,
  method: 'get',
  pathSegments: freeze(['v1/topic-preferences'])
});

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV2` from
 * `rpc-client-utils`.
 *
 * get-/academy/learning-center/recommendations/v1/track/{trackId}
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:RecommendationResource+type:symbol+getTrackRecommendations&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Recommendation-get-%2Facademy%2Flearning-center%2Frecommendations%2Fv1%2Ftrack%2F%7BtrackId%7D'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/get/api.hubapi.com%2Facademy%2Flearning-center%2Frecommendations%2Fv1%2Ftrack%2F%28%28%7BtrackId%7D%29%29?showRequestDetails=true&body=&authType=app&headers=Accept:%20application%2Fjson%0AContent-Type:%20*%2F*)</span></span><span style='padding-left: 12px'></span></span>
 */
export const getTrackRecommendationsRpc = freeze({
  baseUrl,
  method: 'get',
  pathSegments: freeze(['v1/track', pathParameterPlaceholder]),
  pathParameters: freeze(['trackId'])
});

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV2` from
 * `rpc-client-utils`.
 *
 * get-/academy/learning-center/recommendations/v1/user
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:RecommendationResource+type:symbol+getUserRecommendations&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Recommendation-get-%2Facademy%2Flearning-center%2Frecommendations%2Fv1%2Fuser'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/get/api.hubapi.com%2Facademy%2Flearning-center%2Frecommendations%2Fv1%2Fuser?showRequestDetails=true&body=&authType=app&headers=Accept:%20application%2Fjson%0AContent-Type:%20*%2F*)</span></span><span style='padding-left: 12px'></span></span>
 */
export const getUserRecommendationsRpc = freeze({
  baseUrl,
  method: 'get',
  pathSegments: freeze(['v1/user'])
});

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV2` from
 * `rpc-client-utils`.
 *
 * post-/academy/learning-center/recommendations/v1/feedback
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:RecommendationResource+type:symbol+feedback&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Recommendation-post-%2Facademy%2Flearning-center%2Frecommendations%2Fv1%2Ffeedback'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/post/api.hubapi.com%2Facademy%2Flearning-center%2Frecommendations%2Fv1%2Ffeedback?showRequestDetails=true&body=%7B%22entityId%22:0,%22entityType%22:%22string%22,%22correlationId%22:%22string%22%7D&authType=app&headers=Accept:%20application%2Fjson%0AContent-Type:%20*%2F*)</span></span><span style='padding-left: 12px'></span></span>
 */
export const postV1RecommendationsFeedbackRpc = freeze({
  baseUrl,
  method: 'post',
  pathSegments: freeze(['v1/feedback'])
});